import axios from 'axios';

export const location = () => {
	return axios.get('https://ipapi.co/json/');
};

export default location;
